module.exports = __webpack_public_path__ + "img/数据归档.c36829c2.svg";